import { render, staticRenderFns } from "./Affiliation.vue?vue&type=template&id=1464fcd2&scoped=true&"
import script from "./Affiliation.vue?vue&type=script&lang=js&"
export * from "./Affiliation.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Affiliation.vue?vue&type=style&index=0&id=1464fcd2&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1464fcd2",
  "7e669181"
  
)

export default component.exports